async function unwrap<T>(res: Response, ctx: string): Promise<T> {
  if (!res.ok) {
    let detail = res.statusText;
    try {
      const body = (await res.json()) as { error?: { message?: string } };
      detail = body.error?.message ?? detail;
    } catch {
      /* keep statusText */
    }
    throw new Error(`${ctx}: ${detail}`);
  }
  const body = (await res.json()) as { data?: T };
  return (body.data ?? ({} as T)) as T;
}

export type PageFull = {
  id: number;
  slug: string;
  title: string;
  body_html: string | null;
  excerpt: string | null;
  published_at: string | null;
  view_count: number;
  helpful_count: number;
  unhelpful_count: number;
  meta_title: string | null;
  meta_description: string | null;
  related_page_ids_json: number[];
  category_slug: string | null;
  category_name: string | null;
};

export async function loadPublicPage(
  tenantSlug: string,
  pageSlug: string,
): Promise<PageFull> {
  const res = await fetch(
    `/api/v1/public/${encodeURIComponent(tenantSlug)}/pages/${encodeURIComponent(pageSlug)}`,
  );
  const data = await unwrap<{ page: PageFull }>(res, "Load page");
  return data.page;
}

export async function voteOnPage(
  tenantSlug: string,
  pageSlug: string,
  helpful: boolean,
): Promise<{ ok: boolean; already_voted_today?: boolean }> {
  const res = await fetch(
    `/api/v1/public/${encodeURIComponent(tenantSlug)}/pages/${encodeURIComponent(pageSlug)}/vote`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ helpful }),
    },
  );
  return unwrap<{ ok: boolean; already_voted_today?: boolean }>(res, "Vote");
}
